import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useHub, useScreen } from "../../../core/Global";
import JobInvoice from "../../crm/jobs/models/JobInvoice";
import FlexRow from "../../../components/base/FlexRow";
import Indicator from "../../../components/base/Indicator";
import Icon from "../../../components/base/Icon";

const COLLECT_JS_URL = "https://secure.nmi.com/token/Collect.js";
// const GATEWAY_JS_URL = "https://secure.nmi.com/js/v1/Gateway.js";

declare global {
  interface Window {
    CollectJS?: {
      configure: (config: any) => void;
      startPaymentRequest: () => void;
    };
    // Gateway?: {
    //   create: (publicKey: string) => {
    //     get3DSecure: () => {
    //       createUI: (options: any) => {
    //         start: (selector: string) => void;
    //         on: (event: string, handler: (data?: any) => void) => void;
    //       };
    //     };
    //   };
    // };
  }
}

interface IProps {
  inv: JobInvoice;
  onClose: () => void;
  onPaied: (inv: JobInvoice) => void;
}
export default function InvoicePay(props: IProps) {
  const { owner, id, token } = useParams();
  const hub = useHub();
  const screen = useScreen();
  const isMobileScreen = screen.width <= 600;

  const [tokenizing, setTokenizing] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [threeDSResult, setThreeDSResult] = useState<any | null>(null);
  const [paymentResultErrorMessage, setPaymentResultErrorMessage] =
    useState("");
  const [collectLoading, setCollectLoading] = useState(true);
  const [zipCode, setZipCode] = useState("");
  const zipCodeRef = useRef("");
  const [zipCodeErrorMessage, setZipCodeErrorMessage] = useState("");

  const [fieldState, setFieldState] = useState({
    ccnumber: { valid: false, touched: false, message: "" },
    ccexp: { valid: false, touched: false, message: "" },
    cvv: { valid: false, touched: false, message: "" },
  });

  const isFormValid =
    fieldState.ccnumber.valid && fieldState.ccexp.valid && fieldState.cvv.valid;

  useEffect(() => {
    setCollectLoading(true);
    let collectFieldsInterval: number | null = null;
    let collectRevealTimeout: number | null = null;

    const oldCollectScript = document.getElementById("nmi-collect-js");
    if (oldCollectScript) {
      oldCollectScript.remove();
    }

    // const oldGatewayScript = document.getElementById("nmi-gateway-js");
    // if (oldGatewayScript) {
    //   oldGatewayScript.remove();
    // }

    // const gatewayScript = document.createElement("script");
    // gatewayScript.id = "nmi-gateway-js";
    // gatewayScript.src = GATEWAY_JS_URL;

    // gatewayScript.onload = () => {
    //   if (!window.Gateway || typeof window.Gateway.create !== "function") {
    //     return;
    //   }

    if (!props.inv.paymentPublicKey) return;
    //   // if (!props.inv.total || props.inv.total <= 0) return;

    //   const gateway = window.Gateway.create(props.inv.paymentPublicKey);
    //   const threeDS = gateway.get3DSecure();

    const collectScript = document.createElement("script");
    collectScript.id = "nmi-collect-js";
    collectScript.src = COLLECT_JS_URL;
    collectScript.setAttribute(
      "data-tokenization-key",
      props.inv.paymentPublicKey,
    );
    collectScript.setAttribute("data-variant", "inline");

    collectScript.onload = () => {
      if (
        !window.CollectJS ||
        typeof window.CollectJS.configure !== "function"
      ) {
        return;
      }

      const handleCollectCallback = (response: any) => {
        const receivedPaymentToken =
          response?.token ?? response?.payment_token ?? null;

        setTokenizing(false);

        if (!receivedPaymentToken) {
          return;
        }

        setProcessing(true);

        hub.Post(
          `/base/public/payment/prime/create/${owner}/${id}`,
          {
            paymentToken: receivedPaymentToken,
            amount: props.inv.total,
            zipCode: zipCodeRef.current,
            currency: "USD",
          },
          (res) => {
            setProcessing(false);

            if (res.success && res.data) {
              setPaymentResultErrorMessage("");
              props.onPaied(res.data);
            } else {
              setPaymentResultErrorMessage(
                res.message ?? "Card payment was not successful!",
              );
            }
          },
        );

        // const nameParts = (props.inv.billingName ?? "").trim().split(/\s+/)
        // const threeDSecureUI = threeDS.createUI({
        //   paymentToken: receivedPaymentToken,
        //   amount: props.inv.total,
        //   currency: "USD",
        //   firstName: "Farhad",
        //   lastName: "Ma",
        //   // email: "",
        //   // address1: "",
        //   // city: "",
        //   // state: "",
        //   postalCode: "19713",
        //   country: "USA"
        // });

        // threeDSecureUI.on("challenge", () => {
        //   console.log("3DS challenge started");
        // });

        // threeDSecureUI.on("complete", async (result: any) => {
        //   setThreeDSResult(result);
        //   console.log("3DS finalized result:", result);

        // hub.Post(
        //   `/base/public/payment/prime/create/${owner}/${id}`,
        //   {
        //     paymentToken: receivedPaymentToken,
        //     amount: props.inv.total,
        //     currency: "USD",
        //   },
        //   (res) => {
        //     setProcessing(false);
        //
        //     if (res.success && res.data) {
        //       setPaymentResultErrorMessage("");
        //       props.onPaied(res.data);
        //     } else {
        //       setPaymentResultErrorMessage(res.message ?? "Card payment was not successful!");
        //       console.log("Prime failed", res);
        //     }
        //   },
        // );
        // });

        // threeDSecureUI.on("failure", (error: any) => {
        //   console.error("3DS failed", error);
        //   setProcessing(false);
        //   setPaymentResultErrorMessage("3DS verification failed.");
        // });

        // threeDSecureUI.start("#threeDSMountPoint")
      };

      window.CollectJS.configure({
        variant: "inline",
        styleSniffer: false,
        customCss: {
          border: "none",
          "background-color": "transparent",
          "box-shadow": "none",
          outline: "none",
          padding: "0",
          height: "32px",
        },
        fields: {
          ccnumber: {
            selector: "#ccnumber",
            title: "Card Number",
            placeholder: "XXXX XXXX XXXX 8014",
          },
          ccexp: {
            selector: "#ccexp",
            title: "Expiry",
            placeholder: "MM / YY",
          },
          cvv: {
            selector: "#cvv",
            title: "CVV",
            placeholder: "XXX",
          },
        },
        validationCallback: (
          field: string,
          status: boolean,
          message: string,
        ) => {
          const rawMessage = message || "";
          const normalizedMessage = rawMessage.toLowerCase();

          let customMessage = rawMessage;

          if (field === "ccnumber") {
            if (normalizedMessage.includes("empty")) {
              customMessage = "Card number is required";
            } else if (
              normalizedMessage.includes("13-19 digits") ||
              normalizedMessage.includes("recognizable card format") ||
              normalizedMessage.includes("card number")
            ) {
              customMessage = "Enter a valid card number";
            }
          }

          if (field === "ccexp") {
            if (normalizedMessage.includes("empty")) {
              customMessage = "Expiry is required";
            } else if (
              normalizedMessage.includes("present or future") ||
              normalizedMessage.includes("expiration")
            ) {
              customMessage = "Enter a valid expiry date";
            }
          }

          if (field === "cvv") {
            if (normalizedMessage.includes("empty")) {
              customMessage = "CVV is required";
            } else if (
              normalizedMessage.includes("cvv") ||
              normalizedMessage.includes("security code")
            ) {
              customMessage = "Enter a valid CVV";
            }
          }
          setFieldState((prev) => ({
            ...prev,
            [field]: {
              valid: status,
              touched: true,
              message: status ? "" : customMessage,
            },
          }));
        },
        callback: handleCollectCallback,
      });
      collectFieldsInterval = window.setInterval(() => {
        const ccReady = !!document.querySelector("#ccnumber iframe");
        const expReady = !!document.querySelector("#ccexp iframe");
        const cvvReady = !!document.querySelector("#cvv iframe");

        if (ccReady && expReady && cvvReady) {
          if (collectFieldsInterval !== null) {
            window.clearInterval(collectFieldsInterval);
            collectFieldsInterval = null;
          }
          collectRevealTimeout = window.setTimeout(() => {
            setCollectLoading(false);
          }, 700);
        }
      }, 50);
    };

    document.head.appendChild(collectScript);

    // document.head.appendChild(gatewayScript);

    return () => {
      if (collectFieldsInterval !== null) {
        window.clearInterval(collectFieldsInterval);
      }
      if (collectRevealTimeout !== null) {
        window.clearTimeout(collectRevealTimeout);
      }
      const collectScript = document.getElementById("nmi-collect-js");
      if (collectScript) {
        collectScript.remove();
      }

      // const gatewayScript = document.getElementById("nmi-gateway-js");
      // if (gatewayScript) {
      //   gatewayScript.remove();
      // }
    };
  }, [owner, id, token]);

  const handleSubmit = () => {
    setPaymentResultErrorMessage("");
    setThreeDSResult(null);

    const trimmedZip = zipCode.trim();

    if (!trimmedZip) {
      setZipCodeErrorMessage("ZIP is required");
      return;
    }

    setZipCodeErrorMessage("");
    zipCodeRef.current = trimmedZip;

    if (!window.CollectJS) return;

    if (!isFormValid) return;

    setTokenizing(true);
    window.CollectJS.startPaymentRequest();
  };

  return (
    <form className="position-relative">
      {processing && (
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-center"
          style={{ background: "rgba(255,255,255,0.65)", zIndex: 60 }}
        >
          <Indicator />
        </div>
      )}
      {collectLoading && (
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-center"
          style={{ background: "#fff", zIndex: 50 }}
        >
          <Indicator />
        </div>
      )}

      <div style={{ visibility: collectLoading ? "hidden" : "visible" }}>
        {paymentResultErrorMessage ? (
          <div className="alert alert-danger mb-2">
            <Icon icon="exclamation-triangle" className="me-2" />
            {paymentResultErrorMessage}
          </div>
        ) : null}
        <FlexRow className="mb-1">
          <div className="fw-bold text-gray-600 fs-7">Credit Card Number</div>
          {fieldState.ccnumber.touched && !fieldState.ccnumber.valid && (
            <span className="ms-2 text-danger small">
              {fieldState.ccnumber.message || "Required!"}
            </span>
          )}
        </FlexRow>
        <div
          style={{
            marginBottom: "16px",
            borderBottom: "2px solid #777",
            minHeight: "30px",
            width: "100%",
            background: "#fff",
          }}
        >
          <div id="ccnumber" style={{ minHeight: "30px", width: "100%" }} />
        </div>
        <div style={{ display: isMobileScreen ? "block" : "flex", gap: "24px" }}>
          <div style={{ flex: 1 }}>
            <FlexRow className="mb-1">
              <div className="fw-bold text-gray-600 fs-7">Expiry Date</div>
              {fieldState.ccexp.touched && !fieldState.ccexp.valid && (
                <span className="ms-2 text-danger small">
                  {fieldState.ccexp.message || "Required!"}
                </span>
              )}
            </FlexRow>

            <div
              style={{
                marginBottom: "16px",
                borderBottom: "2px solid #777",
                minHeight: "30px",
                width: "100%",
                background: "#fff",
              }}
            >
              <div id="ccexp" style={{ minHeight: "30px", width: "100%" }} />
            </div>
          </div>

          <div style={{ flex: 1 }}>            <FlexRow className="mb-1">
              <div className="fw-bold text-gray-600 fs-7">CVV</div>
              {fieldState.cvv.touched && !fieldState.cvv.valid && (
                <span className="ms-2 text-danger small">
                  {fieldState.cvv.message || "Required!"}
                </span>
              )}
            </FlexRow>
            <div
              style={{
                marginBottom: "16px",
                borderBottom: "2px solid #777",
                minHeight: "30px",
                width: "100%",
                background: "#fff",
              }}
            >
              <div id="cvv" style={{ minHeight: "30px", width: "100%" }} />
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <FlexRow className="mb-1">
              <div className="fw-bold text-gray-600 fs-7">ZIP Code</div>
              {zipCodeErrorMessage && (
                <span className="ms-2 text-danger small">
                  {zipCodeErrorMessage}
                </span>
              )}
            </FlexRow>
            <input
              type="text"
              inputMode="numeric"
              maxLength={12}
              style={{
                minHeight: "30px",
                marginBottom: "16px",
                border: "none",
                borderBottom: "2px solid #777",
                borderRadius: 0,
                padding: "0",
                outline: "none",
                width: "100%",
                background: "#fff",
              }}
              placeholder="12345"
              value={zipCode}
              onChange={(e) => {
                const value = e.target.value
                  .replace(/[^0-9-]/g, "")
                  .slice(0, 12);

                setZipCode(value);

                if (value.trim()) {
                  setZipCodeErrorMessage("");
                }
              }}
              onBlur={() => {
                if (!zipCode.trim()) {
                  setZipCodeErrorMessage("ZIP is required");
                }
              }}
            />
          </div>
          {/* <div id="threeDSMountPoint" /> */}
        </div>
        <FlexRow justify="end">
          <button
            type="button"
            className="btn btn-sm btn-secondary me-2"
            onClick={props.onClose}
          >
            Discard
          </button>
          <button
            id="invoicePayBtn"
            type="button"
            disabled={tokenizing || processing || collectLoading}
            className="btn btn-sm btn-primary"
            onClick={handleSubmit}
          >
            {tokenizing || processing ? <Indicator /> : "Pay the Invoice"}
          </button>
        </FlexRow>
      </div>
    </form>
  );
}
